import axios from 'axios';
import { CHAT_BASE_URL } from '../constants/env';

// Use chat service for config requests
const chatApiClient = axios.create({
  baseURL: CHAT_BASE_URL,
  withCredentials: true,
  transformResponse: axios.defaults.transformResponse.concat(
    params => params.data || params
  ),
});

export const fetchChatConfig = params =>
  chatApiClient.get('chat/config', { params }).then(response => response.data);
